(function() {
  'use strict';
  angular.module('common')
  .directive('digitsOnly', function() {
    let regex = /[^0-9]/g;
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function($scope, element, attrs, ngModelController) {
        ngModelController.$parsers.push(function(val) {
          if(!val) return '';
          val = val.replace(regex, '');
          if (!val) {
            ngModelController.$setViewValue('');
            ngModelController.$render();
            return '';
          } else {
            ngModelController.$setViewValue(val);
            ngModelController.$render();
            return val;
          }
        });
      }
    };
  });
})();
